import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { User } from '../models/user';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import {BusyServices} from '../commons/busy.service';


@Injectable()
export class AuthService {
	private getRegisterURI = 'register';
	private findUserURI = 'users/find';
	public user: User;
	public accessToken: string;
	public authChange: BehaviorSubject<User> = new BehaviorSubject<User>(null);

	constructor(private http: HttpClient,
				private busy: BusyServices,
				private router: Router) { }




	findUser(to_search: string): Promise<User[]> {
		return new Promise<User[]>((resolve, reject) => {

			const body = {
				'to_search': to_search,
			};

			const _http = this.http.post(environment.api.baseUrl + this.findUserURI, body,
				environment.api.config).subscribe(
				(data: any) => {
					const users = [];
					data.data.forEach((u) => {
						if (u) {
							users.push(new User(u.user));
						} else {
							users.push(new User(undefined));
						}
					});
					resolve(users);
				});
			this.busy.setBusy(_http);
		});
	}


	goToGaia(checkLocalStorage: boolean) {

		let redirect = false;
		if (checkLocalStorage) {
			if (JSON.parse(localStorage.getItem('already_tried')) === false) {
				redirect = true;
			}
		} else {
			redirect = true;
		}

		if (redirect) {
			localStorage.setItem('already_tried', JSON.stringify(true));
			const gaia_auth_link = environment.gaia.url + environment.gaia.authorizeURI + '?' +
				'client_id=' + environment.gaia.client_id + '' +
				'&response_type=code' +
				'&approval_prompt=auto' +
				'&scope=' + environment.gaia.scope +
				'&redirect_uri=' + environment.gaia.redirect_uri;

			window.location.href = gaia_auth_link;

		}
	}

	login(code: string): Promise<boolean> {
		return new Promise<boolean>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getRegisterURI,
				{ 'code': code },
				environment.api.config).subscribe((data: any) => {
				if (data['error_message']) {
					resolve(false);
					console.log('ERRORE ' + data['error_message']);
				} else {

					this.createSession(data.user, data.accessToken);

					resolve(true);
				}
			}, err => {
				resolve(false);
			});
			this.busy.setBusy(_http);
		});
	}

	createSession(data_user: string, data_token: string) {
		localStorage.setItem('already_tried', JSON.stringify(false));
		this.accessToken = data_token;
		this.user = new User(data_user);
		this.authChange.next(this.user);
		environment.api.config.headers.Authorization = 'Bearer ' + this.accessToken;
		/*Sentry.configureScope((scope) => {
			scope.setUser({'email': this.user.email});
		});*/

	}

	storeTabIndex(tabIndex: number) {
		localStorage.setItem('tabIndex', JSON.stringify(tabIndex));
	}

	getTabIndex() {
		return JSON.parse(localStorage.getItem('tabIndex'));
	}

	is_authenticated(): boolean {
		return this.user ? true : false;
	}

	is_admin(): boolean {
		return this.user?.is_admin;
	}

	is_superadmin(): boolean {
		return this.user?.is_superadmin;
	}

	getAuthenticatedUser(): User {
		return this.user;
	}

	logout() {
		this.user = undefined;
		this.accessToken = '';
		const _http = this.authChange.next(null);
		this.busy.setBusy(_http);
		localStorage.setItem('already_tried', JSON.stringify(true));
		this.router.navigate(['/']);
	}

	getTokenFromAM(): Promise<string>{
    return new Promise<string>((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/x-www-form-urlencoded',
          'Authorization': 'Basic c2N4MV85c0J6TmhZOW9Ra2l5N0Z1clRhSENzYTprNkZoWGYyOW5MU0owd2kxVFlmMEF6d2ZjSVlh'
        })
      };
      const body = 'grant_type=client_credentials';
      const _http = this.http.post(
        `${environment.api.apimanagerUrl}token`, body, httpOptions).subscribe(
        (data: any) => {
          resolve(data);
        });
    });
  }
}
